import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { useSocrativeRouter } from '~teacher/context/RouterContext';

export function NoReport() {
  const socrativeRouter = useSocrativeRouter();
  const handleLaunchQuiz = () => {
    socrativeRouter.routeToLaunch();
  };

  return (
    <div className="flex flex-col items-center gap-6 py-48 px-2">
      <div className="flex flex-col gap-2 items-center">
        <span className="font-display text-md font-500 leading-7">
          {translate('No Reports Found')}
        </span>
        <span className="font-sans text-base">
          {translate(
            'Launch an activity to see graded reports of your students’ progress.'
          )}
        </span>
      </div>
      <UIButton onClick={handleLaunchQuiz}>
        {translate('Launch Activity')}
      </UIButton>
    </div>
  );
}
